<template>
    <div class="d-flex flex-1 h-100 overflow-auto px-4" >
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_BulkCreate")}}</v-toolbar-title>
            </v-toolbar>
        
            <div class="border-top p-4 flex-1 ">
                <div class="row align-items-start  m-0 gap-2" style="flex: unset">
                    <div class="col-md-3 p-0">
                        <v-label>{{ $t("res_Label_Template")}}</v-label>  
                         <multi-select class="light-bg add-arrow" v-model="template" label="name"
                                    track-by="id" open-direction="bottom" :options="templates" :searchable="true"
                                     :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_MenuItems_ChooseTemplate')">
                                    <template slot="option" slot-scope="props">
                                        <div style="height: 50px; width: 100%; display: flex;text-align:start">
                                            <div class="ad__box">
                                                <p class="ad__text__bold">{{ props.option.name }}</p> 
                                            </div>
                                        </div>
                                    </template>
                          </multi-select>

                    </div>
                    <div class="col-md-1 p-0 h-100">
                        <v-label></v-label>
                        <div class="d-flex gap-2 h-100 align-items-end" style="padding-top:5px">
                            <v-btn color="primary" @click="downloadTemplate">{{ $t("res_ButtonText_Download") }}</v-btn>
                            <v-btn color="primary" @click="showMessage = !showMessage" 
                            :title="$t('res_Msgs_Info')" class="p-0">  
                                <v-icon color="white" >mdi mdi-information</v-icon>
                            </v-btn>
                        </div>
                    </div> 
                    <div class="col-6 border shadow"
                         v-show="showMessage" :style="messageStyle">   
                            <p> {{ $t("res_Msgs_CreateBulkMessage1")}}</p>
                            <p class="mb-0"> {{ $t("res_Msgs_EmployeeNumber")}}:  <strong>[EmployeeNumber]</strong>  </p>
                            <p class="mb-0"> {{ $t("res_Msgs_EmployeeName")}}:   <strong>[EmployeeName]</strong></p> 
                            <p class="mb-0" style="padding-top:5px">{{ $t("res_Msgs_CreateBulkMessage2")}}</p>
                    </div> 

                </div>
                <div class="row align-items-start m-0 gap-2" style="flex: unset; padding-top: 25px;">
                    <div class="col-md-3 p-0">
                        <v-label>{{$t("res_Label_UploadTemplate")}}</v-label>
                        <div class="d-flex input-file-container justify-content-between align-items-center">
                            <v-file-input v-model="filedTemplate" :label="$t('res_Label_Choosefile')" prepend-icon="" accept=".docx" ></v-file-input>
                        </div>
                    </div>
                   <div class="col-md-3 p-0 h-100">
                     <v-label></v-label>
                        <div class="d-flex gap-2 h-100 align-items-end" style="padding-top:5px">
                            <v-btn color="primary" @click="handleUploadFilledTemplate">{{ $t("res_Label_GenerateExcel") }}</v-btn>
                        </div>
                    </div> 
                </div>

                <div class="row align-items-start m-0 gap-2" style="flex: unset; padding-top: 25px;">
                    <div class="col-md-3 p-0">
                        <v-label>{{ $t("res_Label_UploadExcel") }}</v-label>
                        <div class="d-flex input-file-container justify-content-between align-items-center">
                            <v-file-input v-model="filedExcel" prepend-icon="" :label="$t('res_Label_Choosefile')"  accept=".xlsx" ></v-file-input>
                        </div>
                    </div>
                    <div class="col-md-3 p-0" v-if="false">
                        <v-label>{{ $t("res_Label_UploadTemplate") }}</v-label>
                        <div class="d-flex input-file-container justify-content-between align-items-center">
                            <v-file-input v-model="filedTemplate2" prepend-icon="" :label="$t('res_Label_Choosefile')"  accept=".docx" ></v-file-input>
                        </div>
                    </div>
                    <div class="col-md-1 p-0 h-100">
                        <v-label></v-label>
                        <div class="d-flex gap-2 h-100 align-items-end" style="padding-top:5px">
                            <v-btn color="primary" @click="handleUploadFilledExcel">{{ $t("res_ButtonText_Upload") }}</v-btn>
                            <v-btn color="primary" @click="openCorrespondingDialog">{{ $t("res_ButtonText_CreateCorrespondence") }}</v-btn>
                        </div>
                    </div>
                </div>

				<div class="d-flex flex-1 flex-column overflow-scroll mt-2" style="max-width:1339px;max-height:320px;overflow:auto"> 
                    <v-data-table style="overflow:scroll"
                        :mobile-breakpoint="0"
                        class="position-relative white flex-1 d-flex overflow-auto elevation-1 CommitteesTable overflow-scroll"
                        disable-sort
                        loading-text="loading..."
                        :no-data-text="$t('res_Label_NoData')"
                        :footer-props="{'items-per-page-text': 'Items per page'}"
                        caption=""
                        hide-default-footer
                        header-fixed
                        :class="{'no-data': excelData.length == 0}"
                        :headers="headers"
                        :items="excelData"
                        item-key="id">
                        <template v-slot:item="row">
                            <tr>
                                <td v-for="(header,index) in headers" :key="index" class="w-25 text-center">
                                    {{ row.item[header.text]}}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </v-card>

         <v-dialog v-model="createCorrespondenceDialog" max-width="800px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t('res_Label_Create_Correspondences') }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="createCorrespondenceDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Category") }} *</label>
                                <v-select v-model="category" :disabled="disableCategory" :items="categories" item-text="name" item-value="id" label="" solo return-object></v-select>
                            </v-col>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Privacy")}} *</label>
                                <v-select v-model="privacy" :items="privacies" item-text="name" item-value="id" label="" solo return-object></v-select>
                                <v-banner v-if="shouldShowPublicPrivacyBanner" icon="mdi-information" outlined class="p-0 my-2">
                                    <span>{{ $t("res_Msgs_PublicPrivacyBanner") }}</span>
                                </v-banner>
                            </v-col>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Priority")}} *</label>
                                <v-select v-model="priority" :items="priorities" item-text="name" item-value="id" label="" solo return-object></v-select>
                            </v-col>
                            <v-col cols="6">
                                <label class="label_required" style="padding-bottom: 10px">{{ $t("res_Label_DocumentDate") }} *</label>
                                <v-menu content-class="p-0" v-model="document_date_menu" :close-on-content-click="false"
                                        :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formattedDate" :label="$t('res_Label_SelectDate')" readonly v-bind="attrs" v-on="on"
                                                        solo append-icon="mdi-calendar" :tabindex="-1">
                                            <template v-slot:append>
                                                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker :locale="lang" v-model="document.documentDate" @input="document_date_menu = false" :max="nowDate"></v-date-picker>
                                </v-menu>
                            </v-col> 
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_SendTo")}} *</label>
                                <StructureUserSelector class="w-100" :showInternalUsers="true" :showExternalUsers="false"
                                    :showInternalStructures="true" :showExternalStructures="true" :excludeSelf="false"
                                    :isMultiple="false" @structureUserSelectChanged="onUserStructureSelected" :selectedStructureUser="user">
                                </StructureUserSelector>
                            </v-col> 
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Recipient")}}*</label>
                                <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                                    :showInternalStructures="category.id != 2" :showExternalStructures="category.id == 2" :excludeSelf="false"
                                    :isMultiple="false"  
                                    @structureUserSelectChanged="onRecipientSelected" 
                                    :selectedStructureUser="Recipient">
                                </StructureUserSelector>
                            </v-col>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_CC")}}</label> 
                                <StructureUserSelector :showInternalUsers="true" :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false" 
										:isMultiple="true" :selectedStructureUsersList="CCItems" @structureUserSelectChanged="onCCSelected">
									</StructureUserSelector>
                            </v-col>

                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Purpose") }} *</label>
                                <v-select v-model="purpose" :items="purposeList" item-text="name" item-value="id" label="" solo return-object></v-select>
                            </v-col> 
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Note")}} *</v-label>
                                <textarea class="text-area" style="height:100px;" v-model="transfer.transferNote"></textarea>
                            </v-col> 
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Subject")}} *</v-label>
                                <textarea class="text-area" style="height:100px;" v-model="document.subject" @input="openBookmarksSelection"></textarea> 
                                <div v-if="showBookmarksSelection" class="selectionDropdown"> 
                                    <ul>
                                        <li v-for="(item, index) in bookmarksExcelList" :class="`${(document.subject.indexOf(item) > -1 && item != '' ? 'selectionDropdownDisabled' : '')}`" :key="index"    @click="selectBookmark(item)">{{ item }}</li>
                                    </ul>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="createCorrespondenceDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" variant="text" @click="createBulkCorrespondences" >
                        {{ $t("res_ButtonText_Generate") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import * as utils from '@/assets/js/common.js'
    import MultiSelect from 'vue-multiselect';
    import { getTransferPurposes } from '@/store/modules/lookups.js'
    import StructureUserSelector from '@/components/StructureUserSelector.vue';

    export default {
        name: 'BulkCreate',
        props: { },
        components:{StructureUserSelector,MultiSelect},
        data: () => ( 
        {
            templateId: 0,
            Recipient: null,
            CCItems: [],
            constants: constants,
            disableCategory: false,
            messageStyle: '',
            showMessage : false,
            showBookmarksSelection: false,
            bookmarksExcelList: [],
            template: {},
            templates: [],
            privacy: {},
            privacies: [],
            priority: {},
            priorities: [],
            purpose: {},
            purposeList: [],
            category: {},
            categories: [],
            subject: "",
            transferNote: "",
            document_date: "",
            user: null,
            users: [],
            filedTemplate: {},
            filedTemplate2: {},
            filedExcel: {},
            createCorrespondenceDialog : false,
            excelData : [],
            headers: [],
            document_date_menu: "",
            nowDate: new Date().toISOString().slice(0, 10),
            document: 
            {
                categoryId: 0,
                priorityId: 0,
                importanceId: 0,
                privacyId: 0,
                subject: "",
                documentDate: "",
            },
            transfer: 
            {
                sendTo: null,
                transferNote: "",
                purposeId: 0,
                Recipient: 0
            },
            formattedDate: "",
            lang: localStorage.getItem('lang')
        }
        ),
        watch: {
            'document.documentDate': function () 
            {
                if (this.document.documentDate != null && this.document.documentDate != '' && this.document.documentDate != undefined)
                    this.formattedDate = utils.dateFormat(this.document.documentDate)
                else {
                    this.document.documentDate = new Date().toISOString().slice(0, 10)
                    this.formattedDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            },
            category(newValue,oldValue)
            {
                if (newValue!=oldValue)
                    this.document.categoryId = this.category.id
            },
            purpose(newValue,oldValue)
            {
                if (newValue!=oldValue)
                this.transfer.purposeId = this.purpose.id
            },
            priority(newValue,oldValue)
            {
                if(newValue!=oldValue)
                    this.document.priorityId = this.priority.id
            },
            privacy(newValue,oldValue) 
            {
                if (newValue!=oldValue)
                    this.document.privacyId = this.privacy.id
            },
        },
        methods:
        {
            resetFields() {
                this.category = {};
                this.privacy = {};
                this.priority = {};
                this.document = {
                    categoryId: 0,
                    priorityId: 0,
                    importanceId: 0,
                    privacyId: 0,
                    subject: "",
                    documentDate: "",
                };
                this.transfer = {
                    sendTo: null,
                    transferNote: "",
                    purposeId: 0,
                    Recipient: 0
                };
                this.user = null;
                this.Recipient = null;
                this.CCItems = [];
                this.purpose = {};
            },
            selectBookmark(item) {
                if(this.document.subject.indexOf(item) > -1) {  return; } 
                const lastIndex = this.document.subject.lastIndexOf('[');
                if (lastIndex !== -1) {
                    // this.document.subject = this.document.subject.substring(0, lastIndex + 1) + item + this.document.subject.substring(lastIndex + 1) + ']'; 
                     const selectedBookmarkTxt = this.document.subject.substring(0, lastIndex ) + item + this.document.subject.substring(lastIndex + 1); 
                     this.document.subject = selectedBookmarkTxt
                }
                this.showBookmarksSelection = false;
            },
            openBookmarksSelection() { 
                  const lastChar = this.document.subject.slice(-1);
                  this.showBookmarksSelection = lastChar === '[';
            },
            onUserStructureSelected(item)
            {
                this.user = item ?? null;
                this.transfer.sendTo = item?.id?.toString().split('-')[0] ?? null;
            }, 
            onRecipientSelected(item)
            { 
                this.Recipient = item
            }, 
            onCCSelected(items)
            {  
			    this.CCItems = items;
            },
            async readFile(file, successHandler) 
            {
                var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) 
                {
                    if (evt.target.readyState == FileReader.DONE) 
                    {
                        var arrayBuffer = evt.target.result, array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) 
                        {
                            fileByteArray.push(array[i]);
                        }

                        successHandler(fileByteArray);
                    }
                }
            },
            downloadTemplate() 
            {
                if (this.template!={}&&this.template!=null&&this.template!=undefined&&this.template.id>0)
                    utils.DownloadFile(constants.baseApiUrl + 'Template/DownloadTemplate?templateId=' + this.template.id, 'template.docx')
                else
                    window.showAlert("Please Select Template", "warning");
            },
            prepareRequestObject() 
            {
                var requestObj = {}
                requestObj.CategoryId = 0
                requestObj.Language = -1
                requestObj.SignatureCount = -1
                requestObj.Tags = ''
                requestObj.Search = ''
                requestObj.Privacy = -1
                return requestObj
            },
            getTemplates()
            {
                let requestObj =  this.prepareRequestObject()
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Template/SearchTemplates', requestObj, { headers: constants.headers })
                    .then(res => 
                    { 
                        this.templates = []
                        if (res.data != null && res.data != undefined) 
                        {
                            res.data.forEach(element => 
                            {
                                this.templates.push(element)
                            })
                        }
                    })
                    .catch(err => this.handleError(err))
                    .finally(() => window.hideLoading())
            },
            getPrivacies()
            {
                axios.get(constants.baseApiUrl + 'Admin/GetPrivacy')
                    .then((res) => 
                    {
                        if (res.data) 
                        {
                            this.privacies=[];
                            this.privacies=res.data;
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getPriorities()
            {
                axios.get(constants.baseApiUrl + 'Admin/GetPriority')
                    .then((res) => 
                    {
                        if (res.data) 
                        {
                            this.priorities = [];
                            this.priorities=res.data;
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getAllCategory()
            {
                axios.get(constants.baseApiUrl + 'Admin/GetAllCategory?isDecreeEnabled='+constants.isDecreeEnabled+"&isCircularEnabled="+constants.isCircularEnabled)
                    .then((res) => 
                    {
                        if (res.data) 
                        {
                            this.categories = []
                            this.categories = res.data
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getPurpose()
            {
                this.purposeList = getTransferPurposes().filter(p => p.id == constants.purposesEnum.ForAction || p.id == constants.purposesEnum.ForSignature || p.id == constants.purposesEnum.CCed || p.id == constants.purposesEnum.Approved || p.id == constants.purposesEnum.Rejected)
            },
            handleUploadFilledTemplate()
            {
                if (this.filedTemplate != null && this.filedTemplate.size != undefined) 
                {
                    this.readFile(this.filedTemplate, (fileBytes) => 
                    {
                        var template = new Object();
                        template.FileSize = this.filedTemplate.size
                        template.ItemBytes = fileBytes
                        template.FileName = this.filedTemplate.name 

                        if (!template.FileName.endsWith('.docx')) 
                        {
                            return  window.showAlert(this.$t("res_Msgs_ErrorTemplate"), "error") 
                        }

                        window.showLoading();
                        axios.post(constants.baseApiUrl + 'Document/GenerateExcelForBulkCreate', template, { headers: constants.headers ,responseType:"blob"})
                            .then(response => {
                                if (response != null) 
                                {
                                    var blob = new Blob([response.data], { type: "application/octetstream" });
                                    var isIE = false || !!document.documentMode;
                                    if (isIE) 
                                    {
                                        window.navigator.msSaveBlob(blob, "excel.xlsx");
                                    }
                                    else 
                                    {
                                        var url = window.URL || window.webkitURL;
                                        var link = url.createObjectURL(blob);
                                        var a = document.createElement("a");
                                        a.setAttribute("download", "excel.xlsx");
                                        a.setAttribute("href", link);
                                        document.body.appendChild(a);
                                        a.click();
                                        document.body.removeChild(a);
                                    }

                                    window.showAlert('res_Msgs_AttachmentDownloaded', 'success')
                                }
                            })
                            .catch(err => console.warn(err))
                            .finally(() => { window.hideLoading() })
                    });
                }
                else 
                {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                }
            },
            handleUploadFilledExcel()
            { 
                // if (this.filedExcel.size != undefined && this.filedTemplate2.size != undefined) 
                
                if (this.filedExcel != null && this.filedExcel.size != undefined ) 
                {
                    this.readFile(this.filedExcel, (fileBytes) => 
                    { 
                            let excel = new Object();
                            excel.FileSize = this.filedExcel.size
                            excel.ItemBytes = fileBytes
                            excel.FileName = this.filedExcel.name 

                            if (!excel.FileName.endsWith('.xlsx') && !excel.FileName.endsWith('.xls')) 
                            {
                                return  window.showAlert(this.$t("res_Msgs_ErrorTemplate"), "error") 
                            }

                            window.showLoading();
                            axios.post(constants.baseApiUrl + 'Document/GetDataFromExcelFile', excel, { headers: constants.headers })
                                .then(response => 
                                {  
                                    
                                    if(response != null && response.data && response.data.records && response.data.records.length == 0)
                                    {
                                        window.showAlert(this.$t('res_Msgs_CreateBulk_ExcelIsEmpty'), 'warning')
                                    } 

                                    if (response != null && response.data && response.data.success) 
                                    {
                                        this.excelData = response.data.records;
                                        var keys = [];
                                        for(let i = 0;i<this.excelData.length;i++)
                                        {
                                            Object.keys(this.excelData[i]).forEach(function(key)
                                            {
                                                if(keys.indexOf(key) == -1)
                                                {
                                                    keys.push(key); ;
                                                }
                                            });
                                        } 
                                        this.headers = [];
                                        this.bookmarksExcelList = [];
                                        for(let i=0;i<keys.length;i++)
                                        { 
                                            this.headers.push({ text: keys[i], value:keys[i] });

                                            if(keys[i] != ''){ 
                                                this.bookmarksExcelList.push(keys[i]);
                                            }
                                        }
                                        this.resetFields();
                                    }
                                    else
                                    {
                                        if (response != null && response.data && response.data.errorId == 2 && response.data.notFoundEmployeeNumber > 0) { 
                                            const EmployeeNumber = response.data.notFoundEmployeeNumber;
                                            window.showAlert(this.$t('res_Label_BulkCreationEmployeeNotFound', {EmployeeNumber}), 'warning')
                                        }   
                                        else
                                        {  
                                            const EmployeeNumber = response.data.notFoundEmployeeNumber;
                                            window.showAlert(this.$t('res_MeetingForm_FailedToUpload'), 'warning')
                                        }   
                                    }
                                })
                                .catch(err =>   window.showAlert(this.$t('res_MeetingForm_FailedToUpload'), 'warning'))
                                .finally(() => { window.hideLoading() }) 
                    });
                }
                else 
                {
                    window.showAlert(this.$t('res_Msgs_UploadExcel'), 'warning')
                }
            },
            openCorrespondingDialog()
            {    
                if (this.filedTemplate == null || this.filedTemplate.size == undefined || this.filedTemplate.size == 0)
                {
                    window.showAlert(this.$t('res_Msgs_uploadTemplate'), 'warning');
                    return;
                } 
                if (this.excelData == null || this.excelData == undefined || this.excelData.length == 0)
                { 
                    window.showAlert(this.$t('res_Msgs_UploadExcel'), 'warning')
                    return;
                } 
                if(this.template == null ||  this.template.id == null  || this.template.id == 0 )
                { 
                    window.showAlert(this.$t('res_Msgs_selectTemplate'), 'warning')
                    return;
                } 
  
                if(this.templates != null && this.templates.length > 0)
                {
                  const selectedTemplate = this.templates.find(s=>s.id == this.template.id);
                  this.category = selectedTemplate == null ? null : this.categories.find(s=>s.id == selectedTemplate.categoryId);
                  this.disableCategory = true;
                } 
                this.createCorrespondenceDialog = true; 
            },
            validate()
            {
                if (!this.priority || !this.privacy || !this.category || !this.document.documentDate || !this.document.subject ||
                    !this.user || !this.purpose || !this.transfer.transferNote || (this.Recipient == null || this.Recipient.id  == null || this.Recipient.id == '' ) )
                {
                    
                    return false
                }
                
                return true
            },
            createBulkCorrespondences()
            { 
                if (this.filedTemplate == null || this.filedTemplate.size == undefined || this.filedTemplate.size == 0)
                {
                    window.showAlert(this.$t('res_Msgs_uploadTemplate'), 'warning');
                    return;
                }
 
                    let payload = {
                        document: this.document,
                        transfer: this.transfer,
                        bookmarks: this.excelData,
                        forwardTo: this.user,
                        templateId: this.template.id, 
                        recipient: this.Recipient, 
                        ccItems: this.CCItems, 
                    }   

                    if (!this.validate())
                    {
                        window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                        return;
                    }   

                        if (this.filedTemplate.size != undefined) 
                        {
                            this.readFile(this.filedTemplate, (filedTemplateBytes) =>
                            {
                                payload.templateFileSize = this.filedTemplate.size
                                payload.templateItemBytes = filedTemplateBytes
                                payload.templateFileName = this.filedTemplate.name
                                
                                window.showLoading();
                                axios.post(constants.baseApiUrl + 'Document/AddBulkCorrespondence', payload, { headers: constants.headers })
                                    .then(res => 
                                    {
                                        this.templates = [];
                                        if (res.data) 
                                        {
                                            this.getTemplates();
                                            this.createCorrespondenceDialog = false;
                                            window.hideLoading();
                                            window.showAlert(this.$t('res_Msgs_BulkCorrespondingCreated'), 'success')
                                        }
                                    })
                                    .catch(err => { this.handleError(err); window.hideLoading(); window.showAlert(this.$t('res_Msgs_Warning'), 'warning')})
                                    .finally(res=> {   window.hideLoading(); })
                            });
                        } 
            },
           
        },
        mounted() 
        {
            this.getTemplates();
            this.getPriorities();
            this.getPrivacies();
            this.getPurpose();
            this.getAllCategory();  
            let lang = localStorage.getItem('lang'); 
            if(lang == null || lang == '') { lang = 'en';}
            lang = lang.toLowerCase(); 
            this.messageStyle =    `position: absolute;
                            ${(lang == 'en' ? 'right' : 'left')}: 8px;
                            top: 7rem;
                            border-radius: 17px;
                            background-color:#EFF2F5`
        },
        computed: {
            shouldShowPublicPrivacyBanner() {
                return this.constants.client_version_Id == 'AdPorts' && this.document.categoryId  == 2 && (this.privacy.id == 6 || this.privacy.name == 'Public')
            }
        }
    }
</script>

<style>
.selectionDropdown {
  position: relative; 
}

.selectionDropdown ul {
  width: 300px;
  position: absolute;
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  background-color: #fff;
  z-index: 1000;
  border-radius: 8px; 
  max-height: 200px;
  overflow-y: auto;
}

.selectionDropdown ul li {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  text-align: center;
  color: #A1AAB1 !important;
  font-family: var(--main-font-family) !important;
  font-weight: 300 !important;
  font-size: 13px !important;
}

.selectionDropdown ul li.selectionDropdownDisabled {
  padding: 8px 12px;
  cursor: not-allowed;
  transition: background-color 0.2s ease-in-out;
  text-align: center;
  background-color: #024976 !important ;
  color:white !important;
  font-family: var(--main-font-family) !important;
  font-weight: 400 !important;
  font-size: 13px !important;
}
 
.selectionDropdown ul li:hover {
  background-color: #EFF2F5; 
  color: black !important;
  font-weight: 500 !important;
}

.selectionDropdown ul li.selectionDropdownDisabled:hover { 
  font-weight: 500 !important;
  color: white !important;
}
</style>


<style scoped>
.input-file-container{
    
    background: #eff2f5;
    border-radius: 10px;
    padding: 2px !important;
    padding-right:10px !important;

}
.v-file-input{
    
    padding: 0;
    border-radius: 5px;
    height: 100%;
    background: #eff2f5;

}
.v-menu__content{
    overflow: scroll !important;
}
</style>